// Helpers PUROS de escena (camino JSON), sin motor de render ni `this`.

import {
  SOLAR_FILL_OPACITY,
  NO_STATUS_RENDER_MODE,
  NO_STATUS_FILL_COLOR,
  NO_STATUS_OUTLINE_ALPHA,
} from '../data/constants'

// Agrupa las entidades de un pictograma por tipo de capa (structures/pilings/modules).
// O(n) una sola vez; las entidades de tipos no contemplados se descartan.
export function groupEntitiesByType(entities) {
  const entitiesByType = {
    structures: [],
    pilings: [],
    modules: [],
  }
  for (const entity of entities || []) {
    if (entitiesByType[entity.type]) {
      entitiesByType[entity.type].push(entity)
    }
  }
  return entitiesByType
}

// Bounding box en coords locales de un conjunto de entidades (rects): { minX, minY, maxX,
// maxY } o null. Lo comparten el detalle (buckets) y la silueta → mismo bbox, así el
// getClientRect del grupo / hover / FitToScreen quedan consistentes.
export function entitiesBBox(entities) {
  if (!entities || entities.length === 0) return null

  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity
  for (const e of entities) {
    if (e.x < minX) minX = e.x
    if (e.y < minY) minY = e.y
    if (e.x + e.width > maxX) maxX = e.x + e.width
    if (e.y + e.height > maxY) maxY = e.y + e.height
  }
  if (!isFinite(minX)) return null

  return { minX, minY, maxX, maxY }
}

// Prepara los datos de dibujo de las entidades de un bloque (sin tocar el motor): bbox en
// coords locales + buckets por color+opacidad+contorno con los rects ya desplazados al
// frame local (origen = minX,minY). El motor luego crea la shape y los pinta en su
// sceneFunc. Devuelve null si no hay nada que dibujar.
//   - con estado: color de estado sólido (opacity SOLAR_FILL_OPACITY)
//   - sin estado, modo 'outline': contorno gris plomo (stroke:true)
//   - sin estado, modo relleno: gris plomo macizo
export function buildEntitiesDrawData(entities) {
  const bbox = entitiesBBox(entities)
  if (!bbox) return null
  const { minX, minY, maxX, maxY } = bbox

  const buckets = new Map()
  for (const e of entities) {
    let fill, opacity, stroke = false
    if (e.status != null) {
      fill = e.fill
      opacity = SOLAR_FILL_OPACITY
    } else if (NO_STATUS_RENDER_MODE === 'outline') {
      fill = NO_STATUS_FILL_COLOR
      opacity = NO_STATUS_OUTLINE_ALPHA
      stroke = true
    } else {
      fill = NO_STATUS_FILL_COLOR
      opacity = e.opacity != null ? e.opacity : 1
    }
    if (!fill) continue

    const key = fill + '|' + opacity + '|' + stroke
    let b = buckets.get(key)
    if (!b) { b = { fill, opacity, stroke, rects: [] }; buckets.set(key, b) }
    // Array plano [x,y,w,h,...] para recorrer rápido al pintar.
    b.rects.push(e.x - minX, e.y - minY, e.width, e.height)
  }

  const drawBuckets = Array.from(buckets.values())
  if (drawBuckets.length === 0) return null

  return { minX, minY, maxX, maxY, buckets: drawBuckets }
}
